import { render, staticRenderFns } from "./CreateEntityDialog.vue?vue&type=template&id=24796200&scoped=true"
import script from "./CreateEntityDialog.vue?vue&type=script&lang=js"
export * from "./CreateEntityDialog.vue?vue&type=script&lang=js"
import style0 from "./CreateEntityDialog.vue?vue&type=style&index=0&id=24796200&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24796200",
  null
  
)

export default component.exports